import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { ContactResponse } from "@myProfile/models";

/**
 * Fetches the caller's contact profile.
 *
 * API: GET contacts/v1/user/Profile[?entitledUserId={id}]
 *
 * Server derives the target sfdcContactId from the caller's JWT via entitlement-service.
 * No contactId in the URL — IDOR closed structurally. Impersonation is signaled via
 * entitledUserId, which RequestService appends automatically when impersonating.
 */
export const fetchContactInformationThunk = createAsyncThunk<ContactResponse, void, ThunkApiConfig>(
  "myProfile/fetchContactInformation",
  async (_, { extra, rejectWithValue }) => {
    try {
      const response = await extra<ContactResponse>("contacts/v1/user/Profile", { method: "GET" });

      if (!response || !response.data) {
        return rejectWithValue("Failed to fetch contact information");
      }

      return response.data;
    } catch (error) {
      console.error("[Contact Information API] Error fetching data:", error);

      return rejectWithValue("Failed to fetch contact information");
    }
  }
);
